import { Module } from '../../../api/module';
import { useRoutes } from '../../../hooks/useRoutes';
import { FilterSearchParam } from '../types/FilterSearchParam';
import { Tab } from '../types/ResultsPageTabs';

type MemberGroup = {
  member: string;
  group: string;
};

type Exercise = {
  id: string;
  isFreeExercise?: boolean;
};

type CreateResultsUrlProps = {
  [FilterSearchParam.SchoolYear]?: string;
  [FilterSearchParam.School]?: string;
  [FilterSearchParam.Module]?: string;
  [FilterSearchParam.Exercises]?: Exercise[];
  [FilterSearchParam.Groups]?: string[];
  memberGroups?: MemberGroup[];
  selectedTab?: Tab;
};

const useNavigateResult = (module?: Module) => {
  const { buildAbsolutePath } = useRoutes();

  const params = {
    subjectSlug: module?.subjectSlug || '',
    methodSlug: module?.methodSlug || '',
    moduleSlug: module?.slug || '',
  };

  const createResultsUrl = ({
    schoolYear,
    school,
    module,
    exercises,
    groups,
    memberGroups,
    selectedTab,
  }: CreateResultsUrlProps) => {
    const searchParams = new URLSearchParams();

    if (selectedTab) searchParams.set('selectedTab', selectedTab);
    if (schoolYear) searchParams.set(FilterSearchParam.SchoolYear, schoolYear);
    if (module) searchParams.set(FilterSearchParam.Module, module);
    if (school) searchParams.set(FilterSearchParam.School, school);
    if (exercises && exercises.length > 0)
      searchParams.set(FilterSearchParam.Exercises, exercises.map(e => `${e.id}-${!e.isFreeExercise}`).join(','));
    if (groups && groups.length > 0) searchParams.set(FilterSearchParam.Groups, groups.join(','));
    if (memberGroups && memberGroups.length > 0)
      searchParams.set(
        'members',
        memberGroups.map(memberGroup => `${memberGroup.group};${memberGroup.member}`).join(','),
      );

    return `${buildAbsolutePath(['MATERIAL', 'MATERIAL.RESULTS'], params)}?${searchParams}`;
  };

  return { createResultsUrl };
};

export default useNavigateResult;
